import Object2D from '../core/Object2D';

export class Line extends Object2D {
    p1: THREE.Vector2;

    p2: THREE.Vector2;

    constructor(p1: THREE.Vector2, p2: THREE.Vector2) {
      super();
      this.type = 'Line';
      this.p1 = p1;
      this.p2 = p2;
    }
}
